import React, {useState} from 'react';
import styles from './Field.module.css';
import {Field, useField} from 'formik';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";

const validatePassword = (value) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!value) {
        return "Le mot de passe est requis.";
    }
    if (!passwordRegex.test(value)) {
        return "Le mot de passe doit contenir au moins 8 caractères, une minuscule, une majuscule et un chiffre.";
    }
    return null;
};

const FieldPassword = ({ placeholder, onChange, label = "Mot de passe", name = "password" }) => {
    const [field, meta, helpers] = useField(name);
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        field.onChange(e);
        if (onChange) {
            onChange(e)
        } else {
            const value = e.target.value;
            const error = validatePassword(value);
            console.error("Erreur de validation de mot de passe :", error);
        }
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={`${styles.field} ${styles.password}`}>
            <label htmlFor={name}>{label}</label>
            <div className={styles.relative}>
                <Field
                    type={showPassword ? "text" : "password"}
                    id={name}
                    name={name}
                    placeholder={placeholder || "Entrez votre mot de passe"}
                    onChange={onChange ? handleChange : field.onChange}
                    style={meta.error && meta.touched ? { borderColor: "var(--clr-error)" } : null}
                />
                <button type="button" onClick={toggleShowPassword} className={styles.togglePassword}>
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
            </div>
            {meta.touched && meta.error ? <div className={"error"} style={{ color: "var(--clr-error)", fontSize: "var(--fs-secondary)", marginLeft: "16px", marginTop: "8px"}}>{meta.error}</div> : null}
        </div>
    );
};

export default FieldPassword;
